import { createRouter, createWebHashHistory } from "vue-router"
import AdminView from "../views/admin/AdminView.vue"
import store from "../store/index.js"

const routes = [
    {
        path: `/`,
        name: "HomeView",
        redirect: "/admin/search/all",
        children: [
            {
                path: `/admin`,
                name: "AdminView",
                component: AdminView,
                redirect: "/admin/search/all",
                children: [
                    {
                        path: "/admin/search/all",
                        name: "SuperSearch",
                        component: () => import("../views/admin/search/SuperSearch.vue"),
                    },
                    {
                        path: "/admin/search/user-all-order",
                        name: "SearchUserAllOrder",
                        component: () => import("../views/admin/search/SearchUserAllOrder.vue"),
                    },
                    {
                        path: "/admin/super/static-folder",
                        name: "SuperStaticFolder",
                        component: () => import("../views/admin/super/StaticFolder.vue"),
                    },
                    {
                        path: "/admin/super/static-file",
                        name: "SuperStaticFile",
                        component: () => import("../views/admin/super/StaticFile.vue"),
                    },
                    // app
                    {
                        path: "/admin/app/article",
                        name: "AppArticle",
                        component: () => import("../views/admin/app/article/AppArticle.vue"),
                    },

                    {
                        path: "/admin/app/article/:id",
                        name: "AddEditAppArticle",
                        component: () => import("../views/admin/app/article/AddEditAppArticle.vue"),
                    },
                    {
                        path: "/admin/app/order-status",
                        name: "AppOrderStatus",
                        component: () => import("../views/admin/app/order-status/AppOrderStatus.vue"),
                    },
                    {
                        path: "/admin/app/order-status/:id",
                        name: "EditAppOrderStatus",
                        component: () => import("../views/admin/app/order-status/EditAppOrderStatus.vue"),
                    },
                    {
                        path: "/admin/app/custom-info",
                        name: "AppCustomInfo",
                        component: () => import("../views/admin/app/custom-info/CustomInfo.vue"),
                    },
                    {
                        path: "/admin/app/version",
                        name: "AppVersion",
                        component: () => import("../views/admin/app/version/AppVersion.vue"),
                    },
                    {
                        path: "/admin/app/version/:id",
                        name: "EditAppVersion",
                        component: () => import("../views/admin/app/version/EditAppVersion.vue"),
                    },
                    {
                        path: "/admin/app/invite",
                        name: "AppInviteList",
                        component: () => import("../views/admin/app/invite/InviteList.vue"),
                    },
                    // user
                    {
                        path: "/admin/user",
                        name: "UserView",
                        component: () => import("../views/admin/user/UserView.vue"),
                    },
                    {
                        path: "/admin/user/:id",
                        name: "EditUser",
                        component: () => import("../views/admin/user/EditUser.vue"),
                    },
                    // ship
                    {
                        path: "/admin/ship",
                        name: "ShipView",
                        component: () => import("../views/admin/ship/ShipView.vue"),
                    },
                    {
                        path: "/admin/ship/:id",
                        name: "EditShip",
                        component: () => import("../views/admin/ship/EditShip.vue"),
                    },

                    // settings
                    {
                        path: "/admin/settings/sub-order-status",
                        name: "SubOrderStatus",
                        component: () => import("../views/admin/settings/sub-order-status/SubOrderStatus.vue"),
                    },
                    {
                        path: "/admin/settings/sub-order-status/:id",
                        name: "EditSubOrderStatus",
                        component: () => import("../views/admin/settings/sub-order-status/EditSubOrderStatus.vue"),
                    },
                    {
                        path: "/admin/settings/public-document",
                        name: "PublicDocument",
                        component: () => import("../views/admin/settings/public-document/PublicDocument.vue"),
                    },
                    {
                        path: "/admin/settings/public-document/:id",
                        name: "EditPublicDocument",
                        component: () => import("../views/admin/settings/public-document/EditPublicDocument.vue"),
                    },
                    // template
                    {
                        path: "/admin/temp",
                        name: "TempList",
                        component: () => import("../views/admin/temp/TempList.vue"),
                    },
                    {
                        path: "/admin/temp/:id",
                        name: "EditTemp",
                        component: () => import("../views/admin/temp/EditTemp.vue"),
                    },

                    // feedback
                    {
                        path: "/admin/feedback",
                        name: "FeedbackView",
                        component: () => import("../views/admin/feedback/FeedbackView.vue"),
                    },
                    {
                        path: "/admin/feedback/:id",
                        name: "EditFeedback",
                        component: () => import("../views/admin/feedback/EditFeedback.vue"),
                    },
                    {
                        path: "/admin/feedback/reason-status/list",
                        name: "FeedbackReasonStatusList",
                        component: () => import("@/views/admin/feedback/reason-status/FeedbackReasonStatusList.vue"),
                    },
                    {
                        path: "/admin/feedback/reason-status/:id",
                        name: "EditFeedbackReasonStatus",
                        component: () => import("@/views/admin/feedback/reason-status/EditFeedbackReasonStatus.vue"),
                    },
                    {
                        path: "/admin/feedback/result-status/list",
                        name: "FeedbackResultStatusList",
                        component: () => import("../views/admin/feedback/result-status/FeedbackResultStatusList.vue"),
                    },
                    {
                        path: "/admin/feedback/result-status/:id",
                        name: "EditFeedbackResultStatus",
                        component: () => import("../views/admin/feedback/result-status/EditFeedbackResultStatus.vue"),
                    },
                    {
                        path: "/admin/feedback/refound-account/list",
                        name: "FeedbackRefundAccountList",
                        component: () => import("../views/admin/feedback/refund-account/FeedbackRefundAccountList.vue"),
                    },
                    {
                        path: "/admin/feedback/burned-orders/list",
                        name: "FeedbackBurnedOrderList",
                        component: () => import("../views/admin/feedback/burned-orders/FeedbackBurnedOrders.vue"),
                    },
                    {
                        path: "/admin/feedback/burned-orders/:id",
                        name: "EditFeedbavckBurnedOrder",
                        component: () => import("../views/admin/feedback/burned-orders/EditFeedbackBurnedOrder.vue"),
                    },
                    {
                        path: "/admin/feedback/refound-account/:id",
                        name: "EditFeedbackRefundAccount",
                        component: () => import("../views/admin/feedback/refund-account/EditFeedbackRefundAccount.vue"),
                    },
                    // staff-discount
                    {
                        path: "/admin/staff-discount/list",
                        name: "StaffDiscountList",
                        component: () => import("../views/admin/staff-discount/StaffDiscountList.vue"),
                    },
                    {
                        path: "/admin/staff-discount/:id",
                        name: "EditStaffDiscount",
                        component: () => import("../views/admin/staff-discount/EditStaffDiscount.vue"),
                    },
                    // push
                    {
                        path: "/admin/push/new-branch",
                        name: "PushByNewBranch",
                        component: () => import("../views/admin/push/PushByNewBranch.vue"),
                    },
                    {
                        path: "/admin/push/file",
                        name: "PushByFile",
                        component: () => import("../views/admin/push/PushByFile.vue"),
                    },
                    {
                        path: "/admin/push/filter",
                        name: "PushByFilter",
                        component: () => import("../views/admin/push/PushByFilter.vue"),
                    },
                    // account
                    {
                        path: "/admin/account",
                        name: "AccountView",
                        component: () => import("../views/admin/account/AccountView.vue"),
                    },
                    {
                        path: "/admin/account/:id",
                        name: "EditAccount",
                        component: () => import("../views/admin/account/EditAccount.vue"),
                    },
                    // temp
                    {
                        path: "/admin/temp",
                        name: "TempList",
                        component: () => import("../views/admin/temp/TempList.vue"),
                    },
                    {
                        path: "/admin/tel-unification",
                        name: "TelUnification",
                        component: () => import("../views/admin/settings/TelUnificationView.vue"),
                    },
                    {
                        path: "/admin/order/unclaimed-goods",
                        name: "UnclaimedGoods",
                        component: () => import("../views/admin/order/UnclaimedGoods.vue"),
                    },
                    {
                        path: "/admin/order/change-weight",
                        name: "ChangeWeightOrder",
                        component: () => import("../views/admin/order/ChangeWeightOrder.vue"),
                    },
                    {
                        path: "/admin/order/change-jpid",
                        name: "ChangeJpidOrder",
                        component: () => import("../views/admin/order/ChangeJpidOrder.vue"),
                    },
                    {
                        path: "/admin/order/change-branch-by-file",
                        name: "ChangeBranchByFile",
                        component: () => import("../views/admin/order/ChangeBranchByFile.vue"),
                    },
                    {
                        path: "/admin/supervision/json-view",
                        name: "JsonView",
                        component: () => import("../views/admin/supervision/JsonView.vue"),
                    },
                    {
                        path: "/admin/console/update-password",
                        name: "UpdatePassword",
                        component: () => import("../views/admin/console/UpdatePassword.vue"),
                    },
                    {
                        path: "/admin/super/update-all-user-pw",
                        name: "UpdateAllUserPw",
                        component: () => import("../views/admin/super/UpdateAllUserPw.vue"),
                    },
                    {
                        path: "/admin/supervision/order-by-oid",
                        name: "OrderByOid",
                        component: () => import("../views/admin/supervision/OrderByOid.vue"),
                    },
                    {
                        path: "/admin/debug/track-push",
                        name: "TrackPush",
                        component: () => import("../views/admin/debug/TrackPush.vue"),
                    },
                    {
                        path: "/admin/batch/statistics",
                        name: "BatchStatistic",
                        component: () => import("../views/admin/batch/BatchStatistic.vue"),
                    },
                    {
                        path: "/admin/branch/statistics",
                        name: "BranchStatistic",
                        component: () => import("../views/admin/statistic/StatisticPage.vue"),
                    },
                    {
                        path: "/admin/ticket/list",
                        name: "TicketList",
                        component: () => import("@/views/admin/ticket/TicketList.vue"),
                    },
                    {
                        path: "/admin/ticket/notify/:id",
                        name: "NotifyTicket",
                        component: () => import("@/views/admin/ticket/NotifyTicket.vue"),
                    },
                    {
                        path: "/admin/debug/track",
                        name: "TrackList",
                        component: () => import("@/views/admin/debug/TrackList.vue"),
                    },
                    {
                        path: "/admin/debug/track/:id",
                        name: "TrackView",
                        component: () => import("@/views/admin/debug/TrackView.vue"),
                    },
                    {
                        path: "/admin/supervision/phone-by-jpid",
                        name: "PhoneByJpid",
                        component: () => import("@/views/admin/supervision/PhoneByJpid.vue"),
                    },
                    {
                        path: "/admin/order/join-warehouse",
                        name: "JoinWarehouse",
                        component: () => import("@/views/admin/order/JoinWarehouse.vue"),
                    },
                    {
                        path: "/admin/order/add-unclaimed-goods",
                        name: "AddUnclaimedGood",
                        component: () => import("@/views/admin/order/AddUnclaimedGood.vue"),
                    },
                    {
                        path: "/admin/order/not-exists",
                        name: "NotExists",
                        component: () => import("@/views/admin/order/NotExists.vue"),
                    },
                    {
                        path: "/admin/verified-excel",
                        name: "VerifiedExcel",
                        component: () => import("../views/admin/ship/excel/VerifiedExcel.vue"),
                    },
                    {
                        path: "/admin/submit-application",
                        name: "SubmitApplication",
                        component: () => import("../views/admin/submit-application/SubmitApplication.vue"),
                    },
                    {
                        path: "/admin/referral-promo",
                        name: "ReferralPromoView",
                        component: () => import("../views/admin/referral-promo/ReferralPromoView.vue"),
                    },
                ],
            },
        ],
    },
    {
        path: "/login",
        name: "LoginView",
        component: () => import("../views/LoginView.vue"),
    },
    {
        path: "/404",
        name: "NotFound",
        component: () => import("../views/NotFound.vue"),
    },
    {
        path: "/test",
        name: "TestView",
        component: () => import("../views/TestView.vue"),
    },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes,
    // base: '/'+locale
})

router.beforeEach((to, from, next) => {
    if (store.getters.hasLogin === true) {
        if (to.matched.length === 0) {
            from.path
                ? next({
                      name: from.name,
                  })
                : next("/404")
        } else {
            next()
        }
        return
    } else if (to.path.indexOf("/login") == -1) {
        store.commit("signOut")
        return
    } else {
        next()
        return
    }
})

export default router
